<template>
	<div class="contain remove-padding-margin">
		<div class="contain remove-padding-margin" id="setproduksi">
			<div class="fixed-top bg-white">
				<div class="nav-center pageDefault">
					<div class="row set-row d-flex">
						<div class="remove-padding navbar-icon-left" @click="back">
							<img class="remove-padding-margin" @click="" src="../../../assets/gambar/back-blue.svg">
						</div>
						<div class="text-center remove-padding flex-1 font-weight-600">
							Atur Detail Produksi
						</div>
						<div class="navbar-icon-right remove-padding">
						
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<main class="">
			<div class="flex-100">
				<div class="flex-1 pad-top-50">
					<div class="text-head mar-top-20 mar-bottom-16 add-padding-default">
						<div class="font-16 color-33333 line-height-25 letter-space-002">
							Bagaimana Anda mengatur proses produksi untuk outlet ini?
						</div>
					</div>
					<div class="accordion" id="accordionExample">
						<div class="baris border-bottom">
							<div class="input-group" style="padding: 20px">
								<div class="custom-control custom-radio remove-padding-lr">
									<input type="radio" id="customRadioDetailProduksi1" name="customRadioDetailProduksi" class="custom-control-input"
									       data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
									       aria-controls="collapseOne" value="ya" @click="optionClicked">
									<label class="custom-control-label" for="customRadioDetailProduksi1">Buat Workshop Baru</label>
								</div>
							</div>
						</div>
						<div class="baris border-bottom">
							<div class="input-group" style="padding: 20px">
								<div class="custom-control custom-radio remove-padding-lr w-100">
									<input type="radio" id="customRadioDetailProduksi2" name="customRadioDetailProduksi" class="custom-control-input"
									       data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true"
									       aria-controls="collapseTwo" value="tidak"
									       @click="optionClicked">
									<label class="custom-control-label" for="customRadioDetailProduksi2">
										Gabungkan dengan workshop lain
									</label>
									<div id="select-workshop" class="m-t-20" style="display: none">
										<label class="remove-margin f-c-midgrey require">Pilih Workshop</label>
										<Select2 class="test-select fl-is-required inputs mod" id="selectDetailProduksi2"
										         v-model="selectedWorkshop"
										         :options="workshopOption"
										         :settings="{ placeholder: 'Pilih Workshop' }"
										         @select="selectWorkshop"/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="button-lanjut add-padding-default">
					<button class="btn btn-login btn-long remove-margin" disabled id="btnNextDetailProduksi"
					@click="saveDetailProduksi">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              id="loading-detail-produksi"
                              style="display: none"></span>
						<span id="textBtn2">Simpan</span>
					</button>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	import Select2 from 'v-select2-component';

	export default {
		name: "DetailProduksi",
		components: { Select2 },
		data() {
			return {
				workshop: [],
				selectedWorkshop: "",
				workshopOption: [],
				requestHeaders: {
					headers: {
						'Authorization': 'Bearer ' + localStorage.getItem('token'),
					}
				},
			}
		},
		props: ["dataoutlet"],
		methods: {
			back() {
				this.clearOption()
				this.$emit("showdetailoutlet")
			},
			optionClicked() {
				if ($("input[name='customRadioDetailProduksi']:checked").val() === 'tidak') {
					$("#select-workshop").slideDown(300);
				} else {
					$("#select-workshop").slideUp(300);
				}
				this.checkValidate()
			},
			selectWorkshop(e) {
				this.selectedWorkshop = e.id;
				this.checkValidate()
			},
			checkValidate() {
				var checked = $("input[name='customRadioDetailProduksi']:checked").val()
				if (checked !== undefined) {
					if (this.selectedWorkshop === "" && checked === "tidak") {
						$("#btnNextDetailProduksi").prop("disabled", true)
						return
					}
					$("#btnNextDetailProduksi").prop("disabled", false)
				} else {
					$("#btnNextDetailProduksi").prop("disabled", true)
				}
			},
			async getSingleWorkshop() {
				this.workshopOption = []
				try {
					const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_workshop_single', this.requestHeaders)
					if (response.data.status) {
						this.workshop = response.data.data;
						for (var i = 0; i < this.workshop.length; i++) {
							this.workshopOption.push({
								"text": this.workshop[i].nama,
								"id": this.workshop[i].idworkshop,
							});
						}
					} else {
						this.$toast.error(response.data.message)
					}
				} catch (e) {
					this.$catch_error_response(e)
				}
			},
			saveDetailProduksi() {
				if ($("input[name='customRadioDetailProduksi']:checked").val() === 'tidak') {
					this.gabungkanWorkshopDenganOutlet()
					return
				}
				this.$emit("buatworkshop")
			},
			async gabungkanWorkshopDenganOutlet() {
				try {
					var formData = new FormData()
					formData.append("idoutlet", this.dataoutlet.idoutlet)
					formData.append("idworkshop", this.selectedWorkshop)
					const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/gabungkan_workshop_to_outlet', formData, this.requestHeaders)
					if (response.data.status) {
						this.$toast.success(response.data.msg)
						this.clearOption()
						this.back();
					} else {
						this.$toast.error(response.data.message)
					}
				} catch (e) {
					this.$catch_error_response(e)
				}
			},
			clearOption(){
				$("input[name='customRadioDetailProduksi']").prop("checked", false)
				this.selectedWorkshop = ""
				$("#select-workshop").hide()
			}
		},
	}
</script>